import * as React from "react";
import { cn } from "../../lib/utils";
import { FORMATTED_BODY_CLASS } from "./formatted-body";

/**
 * Multi-line text field with the same line spacing as {@link FormattedBody}.
 * @param {Object} props
 * @param {string} [props.className]
 * @returns {JSX.Element}
 */
const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[80px] w-full list-scrollbar rounded-md border border-ui-border bg-ui-card px-3 py-2 text-base text-ui-foreground shadow-sm transition-colors md:text-sm",
        FORMATTED_BODY_CLASS,
        "placeholder:text-ui-muted-foreground",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ui-ring focus-visible:ring-offset-2 focus-visible:ring-offset-ui-background",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
